import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7ac3e214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-ui-shadow-container scan-cntr cm-ui-mb15" }
const _hoisted_2 = { class: "info-bar cm-ui-ml20" }
const _hoisted_3 = { class: "red-txt" }
const _hoisted_4 = { class: "blue-txt" }
const _hoisted_5 = { class: "btn-group cm-ui-mr20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeakSummaryCards = _resolveComponent("LeakSummaryCards")!
  const _component_RiskLeakChart = _resolveComponent("RiskLeakChart")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_LeakTerminalChart = _resolveComponent("LeakTerminalChart")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_LeakViewTable = _resolveComponent("LeakViewTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_TerminalViewTable = _resolveComponent("TerminalViewTable")!
  const _component_IgnoreViewTable = _resolveComponent("IgnoreViewTable")!
  const _component_RepairDrawer = _resolveComponent("RepairDrawer")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_TerminalDrawer = _resolveComponent("TerminalDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LeakSummaryCards, { onDrilldown: _ctx.onLeakSummaryDrilldown }, null, 8, ["onDrilldown"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "cm-ui-mt16 cm-ui-mb16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_RiskLeakChart, {
              style: {"height":"380px"},
              onItemClick: _ctx.onRiskLeakChartItemClick
            }, null, 8, ["onItemClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_LeakTerminalChart, {
              style: {"height":"380px"},
              onRepairDrilldown: _ctx.onLeakTerminalChartRepairDrilldown
            }, null, 8, ["onRepairDrilldown"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CmSvgIcon, {
          class: "info-tips cm-ui-mr10",
          name: "assets/icons/summary-stat",
          size: 22,
          color: "var(--el-color-primary)"
        }),
        _createVNode(_component_i18n_t, {
          keypath: "safeProtectionModule.leakSummaryLine",
          tag: "span"
        }, {
          leak: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.leakStat.leak_count), 1)
          ]),
          terminal: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.leakStat.terminal_count), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          loading: !_ctx.scanResult.isFinish,
          size: "small",
          onClick: _ctx.selectTerminals
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.scanResult.isFinish ? _ctx.$t('safeProtectionModule.startScan') : _ctx.$t('safeProtectionModule.scanWaiting', { done: _ctx.scanResult.success_count, total: _ctx.scanResult.scan_total })), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    _createVNode(_component_Card, {
      size: "second",
      class: "cm-ui-mb16",
      title: _ctx.$t('vulnerabilityFixPage.leakPreviewTitle'),
      "body-style": { margin: '-16px', }
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_LeakViewTable, {
          ref: "leakTableRef",
          onViewAll: _ctx.openLeakDrawerAll,
          "scan-refresh": _ctx.refresh
        }, null, 8, ["onViewAll", "scan-refresh"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_Card, {
      size: "second",
      class: "cm-ui-mb16 cm-ui-mt16",
      title: _ctx.$t('vulnerabilityFixPage.terminalLeakPreviewTitle'),
      "body-style": { margin: '-16px', }
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_TerminalViewTable, {
          ref: "terminalTableRef",
          onViewAll: _ctx.openTerminalDrawerAll,
          "scan-refresh": _ctx.refresh
        }, null, 8, ["onViewAll", "scan-refresh"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_Card, {
      size: "second",
      title: _ctx.$t('vulnerabilityFixPage.ignoredPreviewTitle'),
      "body-style": { margin: '-16px', },
      "view-more-button-type": ""
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_IgnoreViewTable, {
          ref: "ignoreTableRef",
          onViewAll: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ignoreDrawerVisible = true))
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      size: "70%",
      modelValue: _ctx.chartLeakRepairDrawerVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chartLeakRepairDrawerVisible) = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.repairLeakTitle'),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_ctx.chartLeakRepairTerminal)
          ? (_openBlock(), _createBlock(_component_RepairDrawer, {
              key: _ctx.chartLeakRepairDrawerKey,
              "current-terminal": _ctx.chartLeakRepairTerminal
            }, null, 8, ["current-terminal"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('safeProtectionModule.drawerAllTerminals'),
      "custom-class": "no-body-margin",
      modelValue: _ctx.terminalDrawerVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.terminalDrawerVisible) = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TerminalViewTable, {
          viewMode: _ctx.TableViewMode.full,
          "scan-refresh": _ctx.refresh,
          "initial-range": _ctx.terminalDrawerInitialRange
        }, null, 8, ["viewMode", "scan-refresh", "initial-range"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('safeProtectionModule.drawerAllLeaks'),
      "custom-class": "no-body-margin",
      modelValue: _ctx.leakDrawerVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.leakDrawerVisible) = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_LeakViewTable, {
          key: _ctx.leakDrawerTableKey,
          "view-mode": _ctx.TableViewMode.full,
          "scan-refresh": _ctx.refresh,
          "initial-kb-number": _ctx.leakDrawerKbQuery,
          "initial-warn-level": _ctx.leakDrawerInitialWarnLevel,
          onUpdatePreview: _cache[3] || (_cache[3] = () => _ctx.leakTableRef.getData())
        }, null, 8, ["view-mode", "scan-refresh", "initial-kb-number", "initial-warn-level"]))
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('safeProtectionModule.drawerAllIgnored'),
      "custom-class": "no-body-margin",
      modelValue: _ctx.ignoreDrawerVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ignoreDrawerVisible) = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IgnoreViewTable, {
          viewMode: _ctx.TableViewMode.full,
          onUpdatePreview: _cache[5] || (_cache[5] = () => _ctx.ignoreTableRef.getData())
        }, null, 8, ["viewMode"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "75%",
      modelValue: _ctx.terminalDrawer,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.terminalDrawer) = $event)),
      direction: "rtl",
      title: _ctx.$t('safeProtectionModule.manualScan'),
      "before-close": _ctx.handleTerminalDrawerClose,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TerminalDrawer, {
          onSyncScanTskId: _ctx.syncScanTskId,
          onCloseTerminalDrawer: _ctx.handleTerminalDrawerClose,
          onAuthSuccess: _ctx.reloadAllPreview
        }, null, 8, ["onSyncScanTskId", "onCloseTerminalDrawer", "onAuthSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "before-close"])
  ], 64))
}